<div class="rd-widget table-widget widget-{{widgetConfig?.widgetId}}" *ngIf="widgetData">
  <table class="widgetTenantRolloverClass widget-large cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="72" class="widget-grid-column widget-header-red" style="text-align: start;">
            <widget-value class="widget-header-red" [align]="'left'" [color]="'white'" [bold]="true">Tenant Rollover</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2" [widget]="this">
        <tr class="dark-grey-line">
          <th scope="col" colspan="4">
            {{'tenantRollover.labelSuite' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'tenantRollover.labelTenant' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'tenantRollover.labelLeaseEnd' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'tenantRollover.labelWALTYears' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'tenantRollover.labelSF' | rdTranslate}}
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear1' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear1 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear2' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear2 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear3' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear3 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear4' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear4 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear5' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear5 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear6' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear6 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear7' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear7 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear8' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear8 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear9' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear9 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear10' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear10 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear11' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear11 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear12' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear12 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear13' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear13 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear14' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear14 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear15' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear15 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="3">
            <div>{{'tenantRollover.labelYear16' | rdTranslate}}</div>
            <div>{{widgetData.usTenantRolloverNDateYear16 | rdLocalizedDate}}</div>
          </th>
          <th scope="col" colspan="4">
            {{'tenantRollover.labelTotal' | rdTranslate}}
          </th>
        </tr>
      </dynamic-growth-row>
    </thead>
    <tbody class="extraTbody">
      <ng-container *ngFor="let entry of widgetData.rows; let i = index">
        <dynamic-growth-row [row]="i + 3" [widget]="this">
          <tr [ngClass]="{'light-grey-line': (i % 2 === 0), 'light-grey-line': (i % 2 !== 0)}">
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNSuite}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNTenant}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNLeaseEnd | rdLocalizedDate}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNWALT | rdLocalizedNumber:2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNArea | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear1 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear2 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear3 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear4 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear5 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear6 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear7 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear8 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear9 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear10 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear11 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear12 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear13 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear14 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear15 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="3">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNValueYear16 | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usTenantRolloverNTotal | rdLocalizedNumber:0}}</widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
      </ng-container>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 3" [widget]="this">
        <tr class="dark-grey-line">
          <td colspan="12">
            <div>Total Leasable Square Feet</div>
          </td>
          <td colspan="4">
            <div>{{widgetData.usTenantRolloverNWALTTotalLeasableArea}}</div>
          </td>
          <td colspan="4">
            <div>{{widgetData.usTenantRolloverNAreaTotalLeasableArea}}</div>
          </td>
          <td colspan="52">
            &nbsp;
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 4" [widget]="this">
        <tr class="dark-grey-line">
          <td colspan="12">
            <div>Leased SF / SF Expiring</div>
          </td>
          <td colspan="4">
            &nbsp;
          </td>
          <td colspan="4">
            <div>{{widgetData.usTenantRolloverNAreaLeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear1LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear2LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear3LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear4LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear5LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear6LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear7LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear8LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear9LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear10LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear11LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear12LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear13LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear14LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear15LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear16LeasableAreaAreaExpiring}}</div>
          </td>
          <td colspan="4">
            <div>{{widgetData.usTenantRolloverNValueTotalLeasableAreaAreaExpiring}}</div>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 5" [widget]="this">
        <tr class="dark-grey-line">
          <td colspan="12">
            <div>Occupancy % / % GLA Expiring</div>
          </td>
          <td colspan="4">
            &nbsp;
          </td>
          <td colspan="4">
            <div>{{widgetData.usTenantRolloverNAreaOccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear1OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear2OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear3OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear4OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear5OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear6OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear7OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear8OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear9OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear10OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear11OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear12OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear13OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear14OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear15OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear16OccupancyGlaExpiring}}</div>
          </td>
          <td colspan="4">
            <div>{{widgetData.usTenantRolloverNValueTotalOccupancyGlaExpiring}}</div>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 6" [widget]="this">
        <tr class="dark-grey-line">
          <td colspan="12">
            <div>Cumulative Expiration</div>
          </td>
          <td colspan="4">
            &nbsp;
          </td>
          <td colspan="4">
            &nbsp;
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear1CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear2CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear3CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear4CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear5CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear6CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear7CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear8CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear9CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear10CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear11CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear12CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear13CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear14CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear15CumulativeExpiration}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear16CumulativeExpiration}}</div>
          </td>
          <td colspan="4">
            <div>{{widgetData.usTenantRolloverNValueTotalCumulativeExpiration}}</div>
          </td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData?.rows?.length + 7" [widget]="this">
        <tr class="dark-grey-line">
          <td colspan="12">
            <div>Cumulative Percent</div>
          </td>
          <td colspan="4">
            &nbsp;
          </td>
          <td colspan="4">
            &nbsp;
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear1CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear2CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear3CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear4CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear5CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear6CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear7CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear8CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear9CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear10CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear11CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear12CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear13CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear14CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear15CumulativePercent}}</div>
          </td>
          <td colspan="3">
            <div>{{widgetData.usTenantRolloverNValueYear16CumulativePercent}}</div>
          </td>
          <td colspan="4">
            <div>{{widgetData.usTenantRolloverNValueTotalCumulativePercent}}</div>
          </td>
        </tr>
      </dynamic-growth-row>
    </tbody>
  </table>
</div>
